(function(){
  if (window.__clCD) return; window.__clCD = true;
  var SID = 'cl-cart-drawer';
  function root(){ return document.getElementById('cl-cart-drawer'); }
  function open(){ var r = root(); if(!r) return; r.classList.add('is-open'); r.setAttribute('aria-hidden','false'); document.body.classList.add('cl-cd-lock'); }
  function close(){ var r = root(); if(!r) return; r.classList.remove('is-open'); r.setAttribute('aria-hidden','true'); document.body.classList.remove('cl-cd-lock'); }
  function bubble(n){
    document.querySelectorAll('#cart-icon-bubble').forEach(function(a){
      var b = a.querySelector('.cart-count-bubble');
      if (n > 0){ if(!b){ b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); } b.innerHTML = '<span aria-hidden="true">' + n + '</span>'; }
      else if (b) b.remove();
    });
  }
  function swap(html){
    if (!html) return;
    var r = root(); var wasOpen = r && r.classList.contains('is-open');
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cl-cart-drawer'); if(!fresh || !r) return;
    if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden','false'); }
    r.replaceWith(fresh);
    bubble(parseInt(fresh.getAttribute('data-count') || '0', 10));
  }
  function refresh(){
    return fetch('/?sections=' + SID, {credentials:'same-origin'}).then(function(r){ return r.json(); })
      .then(function(j){ swap(j[SID]); }).catch(function(){});
  }
  function busy(on){ var r = root(); if(r) r.classList.toggle('is-loading', !!on); }
  function change(key, qty){
    busy(true);
    return fetch('/cart/change.js', {method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity:qty, sections:SID})})
      .then(function(r){ return r.json(); })
      .then(function(j){ busy(false); if (j.sections && j.sections[SID]) swap(j.sections[SID]); else refresh(); })
      .catch(function(){ busy(false); refresh(); });
  }
  function add(body){
    return fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Accept':'application/json'}, body:body})
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){ return refresh(); }).then(open);
  }
  document.addEventListener('click', function(e){
    var t = e.target; if(!t || !t.closest) return;
    if (t.closest('[data-cl-cd-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('[data-cl-qty]');
    if (q && root() && root().contains(q)) { e.preventDefault(); change(q.getAttribute('data-key'), Math.max(0, parseInt(q.getAttribute('data-cl-qty'), 10))); return; }
    var a = t.closest('[data-cl-add]');
    if (a) { e.preventDefault(); a.disabled = true; var fd = new FormData(); fd.append('id', a.getAttribute('data-cl-add')); fd.append('quantity', '1'); add(fd).catch(function(){ a.disabled = false; }); return; }
    var ap = t.closest('[data-cl-disc-apply]');
    if (ap) { e.preventDefault(); var inp = root().querySelector('[data-cl-disc-input]'); var code = inp && inp.value.trim(); if(!code) return;
      busy(true); fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {credentials:'same-origin'}).then(function(){ busy(false); refresh(); }); return; }
    var opener = t.closest('#cart-icon-bubble, a[href="/cart"], [data-cl-cart-open]');
    if (opener && !(root() && root().contains(opener))) { e.preventDefault(); e.stopPropagation(); open(); refresh(); }
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  document.addEventListener('submit', function(ev){
    var form = ev.target; if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    ev.preventDefault(); ev.stopPropagation();
    var btn = form.querySelector('[type="submit"],[name="add"]'); if (btn) btn.setAttribute('aria-disabled', 'true');
    add(new FormData(form)).catch(function(){ form.submit(); }).then(function(){ if (btn) btn.removeAttribute('aria-disabled'); });
  }, true);
  window.clCartDrawer = {open:open, close:close, refresh:refresh};
})();
